

export const AuthLoading = () => {

    return (
        <div className=" w-screen h-screen flex items-center justify-center">
            Sigmoid 認証中...
        </div>
    );
}